import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { QueryKey } from 'core/react-query/queryClient';
import { boxStatsQuery } from 'networking/mindfeed/queries/boxStats';
import type { BoxId } from 'models/Box';
import type { BoxStats } from 'models/BoxStats';

type QueryKeyType = [QueryKey.BOX_STATS, BoxId?];

type Options = Omit<
  UseQueryOptions<BoxStats, unknown, BoxStats, QueryKeyType>,
  'queryKey' | 'queryFn'
>;

type Params = {
  boxId?: BoxId;
  options?: Options;
};

export default function useBoxStats({ boxId, options = {} }: Params = {}) {
  // Shares its definition with the space machine, which may have started it
  // already for the box in the URL. With no box id the query is defined but
  // doesn't run (see boxStatsQuery).
  const query = useQuery({
    ...boxStatsQuery(boxId),
    placeholderData: (previousData) => previousData,
    ...options,
  });

  const canRun = !!boxId && (options?.enabled ?? true);

  return {
    ...query,
    isLoading: canRun && query.isPending,
  };
}
